import React, { useEffect, useState, useContext } from "react";

import { firebaseLanguageSetup } from "../firebase";
import { GetTranslationsFile } from "../server-requests/serverRequests";
import { AuthContext } from "./authContextProvider";
import { InProgress } from "./shared/loading";

export const LanguageContext = React.createContext();

let translations = [];
export const getTranslation = (code) => {
  if (translations && translations.length > 0) {
    for (let translation of translations) {
      let language = localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage")
        : "en";
      if (code === translation.code) {
        return translation[language];
      }
    }
  }
  return "***NO TRANSLATION***";
};

export const LanguageProvider = (props) => {
  const { snackbarHandler } = useContext(AuthContext);
  const [languageLoading, setLanguageLoading] = useState(true);
  const [lang, setLang] = useState(
    localStorage.getItem("currentLanguage")
      ? localStorage.getItem("currentLanguage")
      : "en"
  );
  const [languages, setLanguages] = useState([]);
  const [translate, setTranslate] = useState(true);

  useEffect(() => {
    let isMounted = true;
    if (translate) {
      let current = localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage")
        : "en";
      firebaseLanguageSetup(current);
      setLanguages(current);
      GetTranslationsFile()
        .then((data) => {
          translations = data.translations;
          if (isMounted) {
            setLanguages(data.languages);
            setLanguageLoading(false);
            setTranslate(false);
          }
        })
        .catch(() => {
          setTranslate(false);
          setLanguages([]);
          translations = [];
          let message =
            current === "pt"
              ? "Ocorreu um erro, por favor tente mais tarde..."
              : "An error has ocurred, please try again later...";
          snackbarHandler(message);
        });
    }
    return () => (isMounted = false);
  }, [translate, snackbarHandler]);

  return (
    <LanguageContext.Provider
      value={{
        languageLoading,
        setLanguageLoading,
        lang,
        setLang,
        languages,
        setTranslate,
      }}
    >
      {languageLoading && translate ? <InProgress /> : props.children}
    </LanguageContext.Provider>
  );
};
